export const templatesMocked = [
    { id: 1, name: "Guest Network", description: "Guest network template" },
    { id: 2, name: "Open template", description: "Open  template" },
    { id: 3, name: "Free template", description: "Free  template" },
    { id: 4, name: "Sold template", description: "Free  template" },
    { id: 5, name: "Another template", description: "Free  template" },
    { id: 6, name: "No template", description: "Free  template" },
    { id: 7, name: "Every template", description: "Free  template" }
];
